import Vue from 'vue'
import configs from '@/configs'
import store from '@/store'

function getToken() {
  if (store && store.state && store.state.authentication && store.state.authentication.token) {
    return store.state.authentication.token
  }

  if (Vue.prototype.$store && Vue.prototype.$store.state && Vue.prototype.$store.state.authentication) {
    return Vue.prototype.$store.state.authentication.token
  }

  try {
    const jwt = localStorage.getItem('jwt')
    if (jwt) {
      return jwt
    }

    const vuexState = localStorage.getItem('vuex')
    if (vuexState) {
      const parsedVuex = JSON.parse(vuexState)
      if (parsedVuex && parsedVuex.authentication && parsedVuex.authentication.token) {
        return parsedVuex.authentication.token
      }
    }

    const raw = localStorage.getItem('authentication')
    if (raw) {
      const parsed = JSON.parse(raw)
      if (parsed && parsed.token) {
        return parsed.token
      }
    }
  } catch (e) {
    return null
  }

  return null
}

function headers(extra = {}) {
  const token = getToken()
  const reqHeaders = {
    accept: 'application/json',
    ...extra
  }

  if (token) {
    reqHeaders.Authorization = `Bearer ${token}`
  }

  return { headers: reqHeaders }
}

function normalize(path) {
  if (!path) return configs.API
  return path.startsWith('http') ? path : `${configs.API}${path}`
}

import { request_payload } from '@/commons/hpod'

export default {
  query(path, params = {}) {
    const query = request_payload(params);
    const url = `${normalize(path)}${query}`
    return Vue.http.get(url, headers())
  },

  get(path, params = {}) {
    return this.query(path, params)
  },

  post(path, data = {}, options = {}) {
    return Vue.http.post(normalize(path), data, { ...headers(), ...options })
  },

  put(path, data = {}, options = {}) {
    return Vue.http.put(normalize(path), data, { ...headers(), ...options })
  },

  delete(path, options = {}) {
    return Vue.http.delete(normalize(path), { ...headers(), ...options })
  }
}
